import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import useCommonStore from 'store/useCommonStore';
import styled from 'styled-components';

import useCheckSession from 'hooks/app/useCheckSession';
import useRedirect from 'hooks/app/useRedirect';
import PageRouter from 'pages/PageRouter';
import CoreToast from 'shared/CoreToast';

import './styles/global.css';
import 'overlayscrollbars/overlayscrollbars.css';

const PageBox = styled.div`
	width: 100%;
	height: 100vh;
	overflow: hidden;
`;

function App() {
	// store
	const { mount, text, permanant, is_error } = useCommonStore(
		(state) => state.toast_data,
	);
	const setMount = useCommonStore((state) => state.setToastData);

	// hooks
	useCheckSession();
	useRedirect();

	return (
		<>
			<PageBox>
				<PageRouter />
				<CoreToast
					text={text}
					permanent={permanant}
					mount={mount}
					is_error={is_error}
					setMount={(value: boolean | string) => setMount('mount', value)}
					max_width="800px"
				/>
			</PageBox>
			<ReactQueryDevtools initialIsOpen={false} />
		</>
	);
}

export default App;
